import React from 'react';
import ReactDOM from 'react-dom/client';
import "./styles/index.css"
import "./styles/fonts.css"
import App from './App';
import { BrowserRouter } from "react-router";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);